import React from 'react'
import { Text } from 'components/base'
import EntryPlaceholder from '../EntryPlaceholder'

export default function PaywallSection({
  title,
  firstCallout,
  secondCallout = null,
  renderPlaceholderIcon = () => null,
  rowsTitle,
  rowsValueLabel,
}) {
  return (
    <div style={{ width: 300 }}>
      <Text.Subtitle className="margin-bottom-large shade-30">
        {title}
      </Text.Subtitle>

      <section>
        <div className="flexbox">
          <Text.Callout className="uppercase margin-bottom-medium pointer shade-40">
            {firstCallout}
          </Text.Callout>
          {secondCallout && (
            <Text.Callout className="uppercase margin-bottom-medium pointer margin-left-normal shade-40">
              {secondCallout}
            </Text.Callout>
          )}
        </div>
        <div>
          <header className="flexbox flexbox-space-between margin-bottom-normal">
            <Text.Detail>{rowsTitle}</Text.Detail>
            <Text.Detail>{rowsValueLabel}</Text.Detail>
          </header>
          <main>
            {Array(5)
              .fill(null)
              .map((_, index) => (
                <EntryPlaceholder
                  key={index}
                  renderPlaceholderIcon={renderPlaceholderIcon}
                />
              ))}
          </main>
        </div>
      </section>
    </div>
  )
}
